<template>
  <table v-if="quote" class="table mb-5">
    <thead>
      <tr>
        <th class="text-left" scope="col" v-dynamic-content:pv_overview_summary_title></th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <!-- show when contractPrice exists and contractPriceExclVAT not given -->
      <tr v-if="iquote.energyConsumption">
        <td class="text-left" v-dynamic-content:pv_overview_summary_usage></td>
        <td class="text-right">{{ iquote.energyConsumption | formatKwh }}</td>
      </tr>
      <tr v-if="quote.inverterSumACPowerkVA && content.pv_overview_summary_acpower">
        <td class="text-left" v-dynamic-content:pv_overview_summary_acpower></td>
        <td class="text-right">{{ quote.inverterSumACPowerkVA | formatAmount }}</td>
      </tr>
      <tr v-if="quote.panelSumPowerKwp">
        <td class="text-left" v-dynamic-content:pv_overview_summary_power></td>
        <td class="text-right">{{ quote.panelSumPowerKwp | formatKwp }}</td>
      </tr>
      <tr v-if="quote.detailOverview.yearlyProductionDecreaseOfPV">
        <td class="text-left" v-dynamic-content:pv_overview_summary_productiondecrease></td>
        <td class="text-right">
          {{ quote.detailOverview.yearlyProductionDecreaseOfPV | formatPercentage(2) }}
        </td>
      </tr>
      <tr v-if="quote.detailOverview.energyPrice">
        <td class="text-left" v-dynamic-content:pv_overview_summary_energyprice></td>
        <!-- In the backend we use a three decimals energyprice for precision in the calculations (e.g. savings). 
        In the frontend we show two decimals to comply to the international standards / norms -->
        <td class="text-right">{{ quote.detailOverview.energyPrice | formatCurrency(2) }}</td>
      </tr>
      <tr v-if="quote.detailOverview.bareKwhRate">
        <td class="text-left" v-dynamic-content:pv_overview_summary_bare_kwh_rate></td>
        <td class="text-right">{{ quote.detailOverview.bareKwhRate | formatCurrency(2) }}</td>
      </tr>
      <tr v-if="quote.detailOverview.yearlyEnergyPriceIndexation">
        <td class="text-left" v-dynamic-content:pv_overview_summary_energyindex></td>
        <td class="text-right">
          {{ quote.detailOverview.yearlyEnergyPriceIndexation | formatPercentage(1, 0) }}
        </td>
      </tr>
      <!-- TODO: Remove condition country when odoo stops returning green certificatecost for customers not from Brussels -->
      <template v-if="isBrussels">
        <tr v-if="quote.detailOverview.numberOfGreenCertificatesPerMW">
          <td class="text-left" v-dynamic-content:pv_overview_summary_greencertificates_count></td>
          <td class="text-right">
            {{ quote.detailOverview.numberOfGreenCertificatesPerMW | formatAmount(1) }}
          </td>
        </tr>
        <tr v-if="quote.detailOverview.greenCertificatesCost">
          <td class="text-left" v-dynamic-content:pv_overview_summary_greencertificates_price></td>
          <td class="text-right">
            {{ quote.detailOverview.greenCertificatesCost | formatCurrency }}
          </td>
        </tr>
      </template>

      <tr v-if="quote.detailOverview.directEnergyUsagePercentage">
        <td class="text-left" v-dynamic-content:pv_overview_summary_energieconsumption></td>
        <td class="text-right">
          {{ quote.detailOverview.directEnergyUsagePercentage | formatPercentage(0) }}
        </td>
      </tr>
      <tr v-if="quote.detailOverview.batterySelfConsumption">
        <td class="text-left" v-dynamic-content:pv_overview_summary_battery_selfconsumption></td>
        <td class="text-right">
          {{ quote.detailOverview.batterySelfConsumption | formatPercentage(0) }}
        </td>
      </tr>
      <tr v-if="quote.detailOverview.prosumerTariff">
        <td class="text-left">
          <p class="mb-0" v-dynamic-content:pv_overview_summary_prosumententarief></p>
          <p
            class="mb-0 text-muted"
            v-dynamic-content:pv_overview_summary_prosumententarief_text
          ></p>
        </td>
        <td class="text-right">{{ quote.detailOverview.prosumerTariff | formatCurrency }}</td>
      </tr>

      <tr v-if="quote.detailOverview.injectionTariff && country === 'be'">
        <td class="text-left">
          <p class="mb-0" v-dynamic-content:pv_package_summary_injection_tariff></p>
          <p
            class="mb-0 text-muted"
            v-dynamic-content:pv_package_summary_injection_tariff_subtext
          ></p>
        </td>
        <td class="text-right">{{ quote.detailOverview.injectionTariff | formatCurrency(2) }}</td>
      </tr>
      <tr v-if="quote.detailOverview.paybackPeriodInYears">
        <td class="text-left" v-dynamic-content:pv_package_paybacktime_title></td>
        <td class="text-right">{{ quote.detailOverview.paybackPeriodInYears }}</td>
      </tr>
      <tr v-if="quote.detailOverview.internalRateOfReturn">
        <td class="text-left" v-dynamic-content:pv_overview_summary_rendement></td>
        <td class="text-right">
          {{ quote.detailOverview.internalRateOfReturn | formatPercentage(1, 0) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'DetailGeneralInformation',
  props: ['quote'],
  computed: {
    isBrussels() {
      return this.$store.getters.isBrussels
    },
    country() {
      return this.$store.getters.country
    }
  }
}
</script>
